import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '权限名称',
      placeholder: '请输入权限名称'
    },
    {
      field: 'status',
      type: 'select',
      label: '状态',
      placeholder: '请选择权限状态',
      options: [
        { title: '正常', value: 1 },
        { title: '禁用', value: 0 }
      ]
    },
    {
      field: 'createdTime',
      type: 'datepicker',
      label: '创建时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD'
      }
    }
  ]
}
